import React from "react";
import { Info, X } from "lucide-react";
import FilterFieldInput, { BooleanChoices } from "./FilterFieldInput";

// Label with the optional ⓘ hint (`field.hint`, shown as a tooltip).
const FieldLabel = ({ field }) => (
  <span className="inline-flex items-center gap-1 min-w-0 text-[13px] font-medium text-text_primary">
    <span className="truncate">{field.label}</span>
    {field.hint && (
      <span title={field.hint} aria-label={field.hint} className="flex-shrink-0 text-text_muted cursor-help">
        <Info size={13} />
      </span>
    )}
  </span>
);

// One field inside a filter section. Booleans sit on one line (label left,
// Any / Yes / No right); every other type shows its label above an
// always-visible editor, with a "Clear" link once it holds a value.
const FilterField = ({ field, value, active, onChange, options, loading, error, timeFormat }) => {
  if (field.type === "boolean") {
    return (
      <div className="flex items-center justify-between gap-3">
        <FieldLabel field={field} />
        <BooleanChoices field={field} value={value} onChange={onChange} />
      </div>
    );
  }

  return (
    <div>
      <div className="flex items-center justify-between gap-2 mb-1.5 min-h-[18px]">
        <FieldLabel field={field} />
        {active && (
          <button
            type="button"
            onClick={() => onChange(undefined)}
            aria-label={`Clear ${field.label}`}
            className="flex-shrink-0 inline-flex items-center gap-0.5 text-[11px] font-medium text-text_muted hover:text-primary"
          >
            <X size={12} />
            Clear
          </button>
        )}
      </div>
      <FilterFieldInput
        field={field}
        value={value}
        onChange={onChange}
        options={options}
        loading={loading}
        error={error}
        timeFormat={timeFormat}
      />
    </div>
  );
};

export default FilterField;
